<brisk-markets-grid
  id="marketGrid"
  [dataSource]="marketConditions"
  (stockSelected)="onStockSelected($event)"
  (dblClicked)="onDoubleClicked()"
  [clickMode]="'click'"
></brisk-markets-grid>
